import { cn } from "@/lib/chillnn/cn";
import dayjs from "@/lib/dayjs";

import { useCalender } from "../../../context/calendar/calendar-context";
import { isDayPickerRange } from "../../../types/calendar-range";
import { isDayPickerSingle } from "../../../types/calendar-single";

import type { CalendarDayType } from "../../root/use-initialize/utils";

export function useClassName(dayRangeItem: CalendarDayType): string {
	const calendar = useCalender();
	const { hideYear, canSelectPastDate } = calendar;

	/**
	 * カレンダーの表示上、表示されているが先月や来月の日付のスタイル
	 */
	const differentMonthClassName = [
		dayRangeItem.isDifferentMonth && "text-white cursor-default pointer-events-none opacity-0",
	];

	/**
	 * 選択可能な日付のスタイル
	 */
	const selectableClassName = [calendar.selected !== dayRangeItem.fullDate && "hover:bg-zinc-100"];

	/**
	 * rangeで選択している場合の、最初と最後の日付の間の日付のスタイル
	 */
	const middleClassName = (function () {
		if (isDayPickerRange(calendar)) {
			const { from, to } = calendar.selected;

			if (from && to) {
				const fromDayjs = dayjs(from);
				const toDayjs = dayjs(to);
				const currentDayjs = dayjs(dayRangeItem.fullDate);

				const className = "bg-zinc-200";

				return (
					currentDayjs.isAfter(fromDayjs) && currentDayjs.isBefore(toDayjs) && className //
				);
			}
		}
	})();

	/**
	 * 選択された日付のスタイル
	 */
	const selectedClassName = (function () {
		const className = "bg-zinc-800 text-white hover:bg-zinc-800 hover:text-white";

		if (isDayPickerRange(calendar)) {
			return (
				(calendar.selected.from === dayRangeItem.fullDate || calendar.selected.to === dayRangeItem.fullDate) &&
				className
			);
		}

		if (isDayPickerSingle(calendar)) {
			return calendar.selected === dayRangeItem.fullDate && className;
		}
	})();

	/**
	 * 選択できない日付のスタイル
	 */
	const disabledClassName = (function () {
		// hideYear pr canSelectPastDate がtrueの場合は過去の日付も選択できる
		const isPastDay = hideYear || canSelectPastDate ? false : dayjs(dayRangeItem.fullDate).isBefore(dayjs(), "day");

		const className = "text-zinc-400 pointer-events-none";

		return isPastDay && className;
		// return isPastDay && "line-through pointer-events-none text-zinc-400";
	})();

	const className = cn(
		"size-12 rounded bg-white text-center tabular-nums", //
		differentMonthClassName,
		selectableClassName,
		selectedClassName,
		middleClassName,
		disabledClassName,
	);

	return className;
}
